'use client';

import ClientThemeProvider from '../../providers/client-theme-provider';
import StoreProvider from '../store-provider';
import CookiesConsentDialogView from './cookies-consent-dialog-view';
import { ENDPOINTS } from '@/app/lib/constants/endpoints';
import { ANALYTICS_CONSENT } from '@/app/lib/constants/cookie-values';
import { configEndpoint } from '@/app/lib/utils/api-utils';
import { useAppDispatch, useAppSelector } from '@/app/lib/store/hooks';
import { setAnalyticsConsent } from '@/app/lib/store/analytics-consent-slice';

const CookiesConsentDialogContainer = () => {
  const analyticsConsent = useAppSelector(
    state => state.analyticsConsent.hasConsent
  );
  const dispatch = useAppDispatch();

  const setConsent = async () => {
    const value = analyticsConsent
      ? ANALYTICS_CONSENT.ACCEPTED
      : ANALYTICS_CONSENT.REJECTED;

    const endpoint = configEndpoint(ENDPOINTS.cookieConsent);

    await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ consent: value })
    });

    window.location.reload();
  };

  const handleSetAnalyticsConsent = (value: boolean) => {
    dispatch(setAnalyticsConsent(value));
  };

  return (
    <StoreProvider>
      <ClientThemeProvider>
        <CookiesConsentDialogView
          analyticsConsent={analyticsConsent}
          setAnalyticsConsent={handleSetAnalyticsConsent}
          onSave={setConsent}
        />
      </ClientThemeProvider>
    </StoreProvider>
  );
};

export default CookiesConsentDialogContainer;
